import React, { useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Col, Container, Row, TabContent, TabPane } from "reactstrap";
import {
  getWebModules,
  getWebModuleDetailsBySeo,
} from "../../redux/homepage/saga";
import { WebModuleDto } from "../../redux/homepage/type";
import { Nav } from "rsuite";
import { Helmet } from "react-helmet";
import { appUrl, baseImageUrl } from "../../redux/base/types/url";
import { Loader } from "../../components";
import { useLocation, useParams } from "react-router-dom";
import Slidewithcontrol from "../../components/Carousel";
import { languageSelector } from "../../redux/languages";
import { isLoading } from "../../redux/loader";

const FeaturesIndex = () => {
  const dispatch = useDispatch();
  const { moduleseo } = useParams();
  const location = useLocation();
  const language = useSelector(languageSelector);
  const loading = useSelector(isLoading);
  const [modules, setModules] = useState<WebModuleDto[]>([]);
  const [active, setActive] = useState<WebModuleDto | undefined>();
 const [title, setTitle] = useState("Rentificial");
  const [desc, setDesc] = useState("Rentificial");
  const [canonical, setCanonical] = useState("Rentificial");
  useLayoutEffect(() => {
    dispatch(
      getWebModules({
        payload: {
          onSuccess: (message, payload) => {
            setModules(payload);
            if (!moduleseo && payload.length > 0) {
              dispatch(
                getWebModuleDetailsBySeo({
                  payload: {
                    onSuccess: (message, payload) => {
                      setActive(payload);
                    },
                    onError: () => {},
                  },
                  id: payload[0].Seo,
                })
              );
            }
          },
          onError: () => {},
        },
      })
    );
  }, [dispatch]);
  useLayoutEffect(() => {
    if (active && moduleseo) {
      setTitle(active.SeoTitle);
      setDesc(active.SeoDescription);
      setCanonical("https://www.rentificial.com/features/" + active.Seo );
    } else {
      setTitle(
        "Smart Car Rental Software Features | Rentificial"
      );
      setDesc(
        
          "Explore Rentificial's powerful car rental software features, from reservations to fleet tracking. Manage your rentals efficiently and grow your business."
      );
      setCanonical("https://www.rentificial.com/features/");
    }
  }, [active, moduleseo]);

  useLayoutEffect(() => {
    if (moduleseo) {
      dispatch(
        getWebModuleDetailsBySeo({
          payload: {
            onSuccess: (message, payload) => {
              setActive(payload);
            },
            onError: () => {},
          },
          id: moduleseo,
        })
      );
    }
  }, [dispatch, moduleseo, language]);

  const generalIntro = `
    <h1 className=" text-center">🚀 Discover All Features of Rentificial in One Place</h1>
    <p>
      Rentificial isn’t just another <strong>car rental software</strong>; it's a full-featured platform designed to streamline every part of your rental business. From managing your car inventory to tracking expenses, Rentificial covers it all with elegant tools and intuitive design. Here's a quick look at what you'll get when you power your business with Rentificial:
    </p>

    <ul>
      <li>📦 <strong>Cars Module</strong>: Easily track license plates, ownership status, car brands, models, and daily costs — all from a unified panel.</li>
      <li>📅 <strong>Reservations</strong>: Manage incoming bookings, calendar availability, and source channels (online, manual, or integrated) from one dashboard.</li>
      <li>📄 <strong>Rental Contracts</strong>: Handle short-term and long-term contracts with built-in status tracking, digital documents, and real-time contract status.</li>
      <li>🔧 <strong>Maintenances</strong>: Schedule and follow up on periodic maintenance, damage repairs, or sudden breakdowns. Set reminders and keep your fleet in top shape.</li>
      <li>💳 <strong>Financial Accounts</strong>: Create, track, and manage accounts, categorize income & expenses, and integrate your financial view.</li>
      <li>💸 <strong>Expenses</strong>: Assign costs per car, categorize operational expenses, and analyze overall spending patterns.</li>
      <li>🍼 <strong>Extra Services</strong>: Offer baby seats, roof boxes, mini fridges, or custom add-ons. These boost revenue while improving customer satisfaction.</li>
      <li>📦 <strong>Suppliers</strong>: Keep all your supplier records, contact info, and service history in one place for better logistics and control.</li>
      <li>🛡️ <strong>Insurance</strong>: Define coverage types, track active policies, and stay up to date on insurance expiry and claims.</li>
      <li>⏰ <strong>Reminders</strong>: Never miss an inspection or payment with smart reminders for maintenance, returns, payments, taxes, and even low balance alerts.</li>
      <li>🆘 <strong>Support</strong>: Our 24/7 support ensures that you get answers when you need them. Whether it's a feature request or technical help, we’re here.</li>
    </ul>

    <p>
      By using Rentificial, you not only simplify your daily operations — you elevate your entire rental experience. Take full control of your fleet, customer relationships, finances, and logistics with a single smart platform.
    </p>

  `;

  
  return (
    <>
      <Helmet>
      <title>{title}</title>
        <meta name="title" content={title} />
        <meta name="description" content={desc} />
        <link
          rel="canonical"
          href={canonical}
        />
      </Helmet>
      <div className="spesificationPage">
        {loading && <Loader />}
        <Container>
          <Row>
            <Col md={3}>
              <Nav
                className="spesificationNavbar font-size-13"
                appearance="subtle"
                vertical
                activeKey={active?.Seo || ""}
              >
                {modules.map((x) => (
                  <Nav.Item
                    key={x.Seo}
                    eventKey={x.Seo}
                    href={`/features/${x.Seo}`}
                  >
                    <span className="mx-2">{x.Name}</span>
                  </Nav.Item>
                ))}
              </Nav>
            </Col>
            <Col md={9}>
              {!moduleseo && (
                <article
                  className="spesificationImageContainer mt-2"
                  dangerouslySetInnerHTML={{ __html: generalIntro }}
                />
              )}
              {active && moduleseo && (
                <TabContent activeTab={active.Id}>
                  <TabPane tabId={active.Id}>
                    <div className="spesificationImageContainer">
                      <Slidewithcontrol items={active.WebModuleSliders} />
                      <article className="mt-3 my-1">
                        <h1>{active.Title}</h1>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: active.Description,
                          }}
                        />
                      </article>
                    </div>
                  </TabPane>
                </TabContent>
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default FeaturesIndex;
